const editorialStatuses: Record<string, string> = {
  AWAITING_REVIEW: 'Aguardando revisão',
  ADJUSTMENT_REQUESTED: 'Ajuste solicitado',
  APPROVED: 'Aprovado',
  REJECTED: 'Rejeitado',
  EDITORIALLY_APPROVED: 'Aprovado editorialmente',
};

export function editorialStatusName(status: string): string {
  return editorialStatuses[status] ?? status.replaceAll('_', ' ').toLowerCase();
}
